import Swiper from 'swiper'
import { Pagination, Navigation, Autoplay, EffectFade } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

window.addEventListener('load', function () {
  const mainElement = document.querySelector('body')
  if (mainElement && mainElement.classList.contains('lp_region')) {
    const voiceSwiper = new Swiper('.sec11_slider', {
      slidesPerView: 1.197,
      spaceBetween: 16,
      centeredSlides: true,
      modules: [Pagination, Navigation],
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 1.1,
          spaceBetween: 16,
        },
      },
    })
  }
})
